import React from "react";
import { Link } from "react-router-dom";
import { LegalPageLayout } from "../components/layout/LegalPageLayout";

const RefundPolicy: React.FC = () => {
  return (
    <LegalPageLayout
      title="Refund Policy"
      description="Refund and cancellation terms for Setgo Innovations, Digistore Pay, SetGo, and Easy Jobs."
    >
      <h1 className="text-3xl font-bold text-secondary-900 mb-2">
        Refund Policy
      </h1>
      <p className="text-secondary-600 text-sm mb-8">
        Last updated: January 2025. Setgo Innovations Private Limited (CIN:
        U85499KL2025PTC092559).
      </p>

      <section className="space-y-6 text-secondary-700">
        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            1. Overview
          </h2>
          <p>
            This Refund Policy applies to payments made for services offered by
            Setgo Innovations Private Limited, including Digistore Pay
            (Fintech), SetGo (Edutech), Easy Jobs (Jobtech), partner
            registration fees, course or programme fees, and other paid
            offerings. Refund eligibility and process may vary by product and
            are subject to the terms below and any product-specific terms
            communicated at the time of purchase.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            2. Digistore Pay and Payment-Related Services
          </h2>
          <p>
            For Digistore Pay partner registration or other one-time or
            recurring fees related to our fintech services: refund requests
            will be considered on a case-by-case basis. If you believe a
            charge was made in error or you are eligible for a refund under
            our terms, contact us at contact@setgo.in with your transaction
            details and reason. Refunds, when approved, will be processed to
            the original payment method within a reasonable period, subject to
            our payment partner’s (e.g. Razorpay) and bank processing times.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            3. SetGo (Edutech) — Courses and Programmes
          </h2>
          <p>
            For SetGo courses, training programmes, or learning subscriptions:
            refund eligibility and timelines will be as stated at the time of
            enrolment or in the specific programme terms. Generally, refund
            requests made within the stated cancellation period and in
            accordance with the programme terms may be eligible for a full or
            partial refund. Requests made after the stated period may not be
            eligible. Contact us at contact@setgo.in with your enrolment
            details to request a refund.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            4. Easy Jobs (Jobtech)
          </h2>
          <p>
            For fees paid in connection with Easy Jobs (e.g. job placement,
            premium features): refund eligibility will be as per the terms
            disclosed at the time of purchase. Where applicable, we will
            process approved refunds to the original payment method within a
            reasonable period.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            5. Duplicate or Erroneous Charges
          </h2>
          <p>
            If you have been charged in duplicate or in error, please contact
            us at contact@setgo.in with your transaction ID and details. We
            will investigate and, where confirmed, process a full refund to the
            original payment method.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            6. Processing Time
          </h2>
          <p>
            Approved refunds are typically processed within 7–14 business days.
            Actual credit to your account may take additional time depending
            on your bank or card issuer. We are not responsible for delays
            caused by third-party payment processors or banks.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            7. Non-Refundable Items
          </h2>
          <p>
            Certain fees or charges may be non-refundable as disclosed at the
            time of purchase or in product-specific terms. For example, once
            a service has been fully consumed or delivered as per the
            agreement, refunds may not be available unless required by law or
            our discretion.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            8. Contact
          </h2>
          <p>
            For refund requests or questions about this policy, contact us at{" "}
            <a
              href="mailto:contact@setgo.in"
              className="text-primary-500 hover:underline"
            >
              contact@setgo.in
            </a>
            . Please include your name, transaction ID, and reason for the
            request. Setgo Innovations Private Limited, headquartered in
            Kerala, India; CIN: U85499KL2025PTC092559.
          </p>
        </div>
      </section>

      <p className="mt-10 text-sm text-secondary-500">
        <Link to="/" className="text-primary-500 hover:underline">
          ← Back to home
        </Link>
      </p>
    </LegalPageLayout>
  );
};

export default RefundPolicy;
